// extracted by mini-css-extract-plugin
export default {"container":"SelectElements_container__9nGny","title":"SelectElements_title__-Nea7"};